<template>
  <footer id="footer">
    <div class="container">
      <div class="row">
        <div class="col-md-4">
          <h6>ABOUT</h6>
          <p>
            The database website provides a convenient way for comprehensive, accurate and efficient retrieval and prediction of Monascus species, natural products, regulatory methods and other data.
          </p>
          <br />
          <p>
            Xiangya School of Pharmaceutical Sciences, Central South University.
            All rights reserved.
          </p>
        </div>
        <div class="col-md-3" style="margin-top: 20px">
          <a href="https://www.revolvermaps.com/livestats/5vepwg6t1ns/"><img src="//rf.revolvermaps.com/h/m/a/0/ff0000/128/30/5vepwg6t1ns.png" width="256" height="128" alt="Map" style="border:0;"></a>
        </div>

        <div class="col-md-5">
          <p class="copyright-text text-right">
           <i class="el-icon-message"></i> E-mail: jiedong@csu.edu.cn<br /><br>
            Copyright © 2022 All Rights Reserved by Artificial
            Intelligence & Drug Design Group.
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style>
#footer {
  background: #34314c;
  color: #ccc;
  padding: 20px 0;
  font-size: 14px;
  line-height: 28px;
}
</style>